/**
 * Events page top-widget registry.
 *
 * Ordered by priority — first provider whose `match()` returns a result is
 * rendered. Add new providers by implementing `EventsWidgetProvider` and
 * inserting them in the correct priority slot below.
 */

import type {
  EventsWidgetContext,
  EventsWidgetProvider,
  EventsWidgetResult,
} from "./types";
import { matchFillProvider } from "./MatchFillProvider";
import { upcomingEligibleProvider } from "./UpcomingEligibleProvider";
import { upcomingRegistrationProvider } from "./UpcomingRegistrationProvider";

const PROVIDERS: EventsWidgetProvider[] = [
  matchFillProvider,
  upcomingRegistrationProvider,
  // 3. unreadMessageProvider — coming soon
  upcomingEligibleProvider,
];

export function pickEventsWidget(
  ctx: EventsWidgetContext
): EventsWidgetResult | null {
  for (const provider of PROVIDERS) {
    const result = provider.match(ctx);
    if (result) return result;
  }
  return null;
}

export type { EventsWidgetContext, EventsWidgetProvider, EventsWidgetResult };
